import React from 'react';
import { AlertCircle, Info } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ErrorStateProps {
  message: string;
  onRetry?: () => void;
  onBack?: () => void;
  title?: string;
  actionLabel?: string;
  variant?: 'error' | 'info';
}

const ErrorState: React.FC<ErrorStateProps> = ({
  message,
  onRetry,
  onBack,
  title,
  actionLabel = 'Try Again',
  variant = 'error',
}) => {
  const isInfo = variant === 'info';
  const handleAction = onBack ?? onRetry;

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center max-w-md mx-auto">
        <div className={isInfo ? 'text-gray-400 mb-4' : 'text-error-500 mb-4'}>
          {isInfo ? (
            <Info className="w-12 h-12 mx-auto" />
          ) : (
            <AlertCircle className="w-12 h-12 mx-auto" />
          )}
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          {title ??
            (isInfo ? 'No submission types available' : 'Error Loading Forms')}
        </h3>
        <p className="text-gray-600 mb-6">{message}</p>
        {handleAction && (
          <Button
            onClick={handleAction}
            className="bg-primary-500 hover:bg-primary-600 text-white"
          >
            {actionLabel}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ErrorState;
